
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthVJ25ftddn9WNFBnamxapvFtP0ifUfuk_45CXRvwUNjSzgMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/jetpark/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93kcatsKLhkhTK8mo6LmTOXeyVg0Osmr7mSH_45qDKRBmgcMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue?macro=true";
import { default as component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPUMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.5.1_db0@0.3.2_eslint@9.35.0_jiti@2.5.1_175d35522c5ff3c9f3b87bd77dd6c13f/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPU } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.5.1_db0@0.3.2_eslint@9.35.0_jiti@2.5.1_175d35522c5ff3c9f3b87bd77dd6c13f/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/jetpark/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/packages/base/pages/[...slug].vue")
  },
  {
    name: component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPU
  }
]